/**
 * パスワード入力のクライアント側チェック（最終判定はサーバ）。
 * BE PasswordPolicyEvaluator と同じ文字種判定を使う。
 */
import { evaluatePasswordRequirements, type EffectivePasswordPolicy } from '@/lib/api/orpc/contracts/auth-password';
export { evaluatePasswordRequirements, type PasswordRequirementCheck } from '@/lib/api/orpc/contracts/auth-password';

/** @deprecated 固定正規表現。ポリシー駆動の evaluatePasswordRequirements を使うこと。 */
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{10,}$/;

/** @deprecated HTML pattern。ポリシー駆動チェックリストへ移行済み。 */
export const PASSWORD_PATTERN = '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[^A-Za-z0-9]).{10,}';
export function areAllPasswordRequirementsMet(password: string, policy: Pick<EffectivePasswordPolicy, 'minLength' | 'requireUppercase' | 'requireLowercase' | 'requireNumber' | 'requireSymbol'>): boolean {
  return evaluatePasswordRequirements(password, policy).every(check => check.met);
}